import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import { loadPronunciationGuideCatalog, loadPronunciationGuideLessonCards } from '../../services/dataApi';
import LessonFlow from '../../components/LessonFlow';

// Interactive lesson for one Pronunciation Guide chapter — loads the
// catalog fresh (rather than trusting router state) so a direct link or a
// refresh both work, then hands the matching chapter to the shared
// LessonFlow player (same one used by topic-lessons/grammar/alphabet/
// common-foundations).
export default function PronunciationGuideLessonPage() {
  const { t } = useTranslation();
  const { chapterId } = useParams();
  const { languagePrefs } = useAuth();
  const targetCode = languagePrefs?.targetLanguage || '';

  const loader = useCallback(async () => {
    const chapters = await loadPronunciationGuideCatalog(targetCode);
    const chapter = chapters.find((c) => c.id === chapterId) || chapters[0];
    if (!chapter) throw new Error('No pronunciation guide chapter available');
    return loadPronunciationGuideLessonCards(targetCode, chapter, chapters);
  }, [targetCode, chapterId]);

  return (
    <LessonFlow
      loader={loader}
      loaderDeps={[targetCode, chapterId]}
      backTo="/learn/pronunciation-guide"
      backLabel={t('pronunciationGuide.title', 'Pronunciation Guide')}
    />
  );
}
